module.exports = __webpack_public_path__ + "static/img/10.225ee07.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/zh/10.png
// module id = HeOj
// module chunks = 0